import { CharacterSearchParams } from "common/api/asocijator/character/type/character_api.type";
import { useCharacterSearchQuery } from "./useCharacterSearch";
import {
  CharacterLetter,
  CharacterResult,
} from "common/character/dto/CharacterResult";
import { SEARCH_NAMES } from "constant/search/search";
import { useEffect, useMemo, useState } from "react";
import { getSignImagePath } from "common/character/character_common";

const filterSortByContainCount = (
  chars: CharacterResult[]
): CharacterResult[] => {
  let filterSortChars: CharacterResult[] = [];
  chars.forEach((item: CharacterResult) => {
    if (
      !filterSortChars.find(
        (filterSortCharacter: CharacterResult) =>
          filterSortCharacter.letter === item.letter
      )
    ) {
      filterSortChars.push(item);
    }
  });
  filterSortChars = filterSortChars.sort(
    (char1: CharacterResult, char2: CharacterResult) =>
      char2.containCount - char1.containCount
  );
  return filterSortChars;
};

export const useCharacterContainTypeLetters = (
  character: CharacterResult | null,
  navType: string,
  initialSearch: boolean = true
): { charLetters: CharacterLetter[]; refetch: Function } => {
  const characterSearchParams: CharacterSearchParams = useMemo(() => {
    return {
      [SEARCH_NAMES.SEARCH_TYPE]: navType,
      [SEARCH_NAMES.CHARACTER_ID]: character?.id,
    };
  }, [navType, character?.id]);

  const { data: characterSearchResult, refetch } = useCharacterSearchQuery(
    characterSearchParams,
    { initialSearch }
  );
  const [charLetters, setCharLetters] = useState<CharacterLetter[]>([]);

  useEffect(() => {
    if (
      character &&
      characterSearchResult &&
      characterSearchResult.resTotal > 0
    ) {
      // console.log(
      //   "useCharacterContainTypeLetters - characterSearchResult.items.length",
      //   characterSearchResult.items.length
      // );

      const relateCharacters = filterSortByContainCount(
        characterSearchResult.items
      );
      const relateLetters: CharacterLetter[] = relateCharacters.map(
        (characterResult: CharacterResult) => {
          const charLetter: CharacterLetter = {
            letter: characterResult.letter,
          };
          const signImage = getSignImagePath(characterResult);
          if (signImage) {
            charLetter.signImage = signImage;
          }

          return charLetter;
        }
      );
      setCharLetters(relateLetters);
    } else {
      setCharLetters([]);
    }
  }, [characterSearchResult]);

  return { charLetters, refetch };
};
